'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Menu, X } from 'lucide-react';

export default function SignUpHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-blue-100 shadow-sm sticky top-0 z-50">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* JOB FINDER Logo */}
        <div className="flex items-center">
          <Image
            src="/assets/images/3753d014-4205-457c-8326-992f24d78af6-1784109448561.png"
            alt="Job Finder Logo"
            width={180}
            height={64}
            className="object-contain h-14 w-auto"
            priority
          />
        </div>

        {/* Desktop nav */}
        <nav className="hidden sm:flex items-center gap-4">
          <Link
            href="/drivers"
            className="text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors"
          >
            Drivers
          </Link>
          <Link
            href="/graduates"
            className="text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors"
          >
            Graduates
          </Link>
          <Link
            href="/login"
            className="text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors"
          >
            Already registered? Sign In
          </Link>
          <Link
            href="/job-listings-screen"
            className="text-sm font-semibold text-white bg-blue-700 border border-blue-700 rounded-lg px-4 py-2 hover:bg-blue-800 transition-colors"
          >
            Browse Jobs
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="sm:hidden p-2 rounded-lg text-blue-700 hover:bg-blue-50 transition-colors"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="sm:hidden bg-white border-t border-blue-100 px-4 py-3 flex flex-col gap-3">
          <Link
            href="/drivers"
            className="text-sm font-semibold text-blue-700 py-2"
            onClick={() => setMenuOpen(false)}
          >
            Drivers
          </Link>
          <Link
            href="/graduates"
            className="text-sm font-semibold text-blue-700 py-2"
            onClick={() => setMenuOpen(false)}
          >
            Graduates
          </Link>
          <Link
            href="/login"
            className="text-sm font-semibold text-blue-700 py-2"
            onClick={() => setMenuOpen(false)}
          >
            Already registered? Sign In
          </Link>
          <Link
            href="/job-listings-screen"
            className="text-sm font-semibold text-white bg-blue-700 rounded-lg px-4 py-2 text-center hover:bg-blue-800 transition-colors"
            onClick={() => setMenuOpen(false)}
          >
            Browse Jobs
          </Link>
        </div>
      )}
    </header>
  );
}